import { useContext, useEffect, useRef } from 'react';
import * as CheckboxPrimitive from '@givebutter/primitives/checkbox';
import { TableRowContext } from 'components/table/TableContext';

interface TableRowRadioInputProps<T> extends CheckboxPrimitive.CheckboxProps {}

const TableRowRadioInput = <T,>(props: TableRowRadioInputProps<T>) => {
    const { row } = useContext(TableRowContext);
    const ref = useRef<HTMLButtonElement>(null);

    useEffect(() => {
        if (ref.current) {
            const td = ref.current.closest('td');
            td?.classList.add('!pr-0', '!w-6');
        }
    }, []);

    const isSelected = row.getIsSelected();

    return (
        <CheckboxPrimitive.Root
            className={
                'radix-state-checked:bg-blue-500 flex h-4 w-4 cursor-pointer items-center justify-center rounded-full border border-gray-300'
            }
            ref={ref}
            checked={isSelected}
            onCheckedChange={row.getToggleSelectedHandler()}
            onClick={e => {
                if (isSelected) {
                    e.preventDefault();
                }
            }}
            {...props}
        >
            <CheckboxPrimitive.Indicator className={'h-1.5 w-1.5 rounded-full bg-white'} />
        </CheckboxPrimitive.Root>
    );
};

export { TableRowRadioInput };
export type { TableRowRadioInputProps };
